import classNames from 'classnames';
import styles from './ThreeColumnSpot.module.scss';
import { UI_Heading } from 'ui/components/1-atoms/Heading/Heading';
import { UI_Link, UI_LinkProps } from 'ui/components/1-atoms/Action/Link/Link';
import { UI_PreviewCardList } from 'ui/components/3-organisms/PreviewCardList/PreviewCardList';
import { UI_Container } from 'ui/components/4-habitats/Container/Container';
import { UI_PreviewCardProps } from 'ui/components/2-molecules/Card/PreviewCard/PreviewCard';
import ColorOptions from 'helpers/types';
export interface UI_ThreeColumnSpotProps {
	className?: string;
	heading?: string;
	ctaLink?: UI_LinkProps;
	items?: UI_PreviewCardProps[];
	bgColor?: ColorOptions;
	globalTheme?: string;
}

export const UI_ThreeColumnSpot: React.FC<UI_ThreeColumnSpotProps> = ({ className, heading, ctaLink, items, bgColor = 'white', globalTheme }) => {
	return (
		<div className={classNames(styles.ThreeColumnSpot, styles[`u-color___${bgColor}`], className)}>
			<UI_Container width="Standard">
				<div className={classNames(styles.ThreeColumnSpot_content)}>
					{heading && (
						<UI_Heading className={styles.ThreeColumnSpot_heading} headingLevel="h2" style="md">
							{heading}
						</UI_Heading>
					)}

					{ctaLink && (
						<UI_Link iconLink={true} className={styles.ThreeColumnSpot_ctaLink} href={ctaLink?.href} globalTheme={globalTheme}>
							{ctaLink?.children}
						</UI_Link>
					)}

					{items && (
						<div className={styles.ThreeColumnSpot_articles}>
							<UI_PreviewCardList items={items} />
						</div>
					)}
				</div>
			</UI_Container>
		</div>
	);
};
